import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "./salesData";
function initials(name: string) {
  return name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
}
const avatarColors = ["bg-[#0d1b3e]", "bg-[#1e4fa3]", "bg-[#c47f10]", "bg-[#2f7d5b]", "bg-[#7a3e9d]"];
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-197" data-mp="36yplgqugkhcz">
      <div className="mx-auto max-w-4xl" data-id="element-198" data-mp="36wwefafxnv4g">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-[#f5a623]" data-id="element-199" data-mp="31zd24g2spsf5">
          Testimonios reales
        </p>
        <h2 className="mt-3 text-center text-3xl font-extrabold uppercase leading-tight text-[#0d1b3e] sm:text-4xl" data-id="element-200" data-mp="2x1binu1gjr35">
          Lo que sienten después de leerlo
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-base text-gray-600" data-id="element-201" data-mp="v9om7cysr3za">
          Personas como vos que dejaron de compararse y empezaron a construir su propio camino.
        </p>

        <div className="mt-12 grid gap-6 sm:grid-cols-2" data-id="element-202" data-mp="h5os1hpjsial">
          {testimonials.map((t, i) => <article key={t.name} className={`rounded-2xl border border-gray-100 bg-gray-50 p-6 shadow-sm ${i === testimonials.length - 1 && testimonials.length % 2 === 1 ? "sm:col-span-2 sm:mx-auto sm:max-w-lg" : ""}`} data-id="element-203" data-mp="m5b4hoxjxuic" data-mpi={i}>
              <div className="flex gap-1 text-[#f5a623]" data-id="element-204" data-mp="zwy0rorhv314">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-5 w-5 fill-current" data-id="element-205" data-mp="14xlpg3s937s6" data-mpi={s} />)}
              </div>
              <p className="mt-4 text-[15px] italic leading-relaxed text-gray-700" data-id="element-206" data-mp="q4sacjgw4to1">
                “{t.quote}”
              </p>
              <div className="mt-5 flex items-center gap-3" data-id="element-207" data-mp="1ius69steywer">
                <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white ${avatarColors[i % avatarColors.length]}`} data-id="element-208" data-mp="1it7fmea7zxm6">
                  {initials(t.name)}
                </div>
                <div data-id="element-209" data-mp="1sk7hwjfxd5zf">
                  <p className="text-sm font-bold text-[#0d1b3e]" data-id="element-210" data-mp="1sjphdam8c5lp">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-211" data-mp="1ofzq2de679wz">
                    {t.age} años · {t.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}